<template>
  <b-navbar
    toggleable="lg"
    style="background-color: #ecf0f1"
    class="navbar-horizontal"
  >
    <b-collapse id="nav-collapse" is-nav>
      <div v-if="this.$route.path == '/' || this.$route.path == '/home'">
        <b-navbar-nav>
          <b-nav-item>
            <b-form-group label="Species" class="text-left">
              <b-form-select
                v-model="speciesID"
                :options="speciesList"
                value-field="id"
                text-field="name"
                class="border-top-0 border-right-0 border-left-0 selectInput"
                @input="getExperiments"
              ></b-form-select>
            </b-form-group>
          </b-nav-item>
          <b-nav-item>
            <b-form-group label="Experiment" class="text-left">
              <b-form-select
                v-model="experimentId"
                :options="experimentList"
                value-field="id"
                text-field="name"
                class="border-top-0 border-right-0 border-left-0 selectInput"
                @input="onExperimentChange"
              ></b-form-select>
            </b-form-group>
          </b-nav-item>
        </b-navbar-nav>
      </div>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right class="mr-4">
          <template #button-content> User </template>
          <b-dropdown-item disabled v-if="isLoggedIn"
            ><strong>{{ this.userName }}</strong></b-dropdown-item
          >
          <template v-for="(router, i) in routerList">
            <div v-bind:key="i">
              <div v-if="isLoggedIn">
                <b-dropdown-item :to="{ name: router }">{{
                  router
                }}</b-dropdown-item>
              </div>
              <div v-else>
                <b-dropdown-item :to="{ name: router }">{{
                  router
                }}</b-dropdown-item>
              </div>
            </div>
          </template>
          <b-dropdown-item v-if="isLoggedIn" @click="logout"
            >Logout</b-dropdown-item
          >
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-brand href="https://rivethammer.com/">
        <b-img
          :src="require('@/rivet_logo_grey.svg')"
          class="rounded mr-2"
          height="40"
          width="164"
          alt="Logo"
        />
      </b-navbar-brand>
    </b-collapse>
  </b-navbar>
</template>
<script>
import { GET_SPECIES, GET_EXPERIMENTS } from "../../graphql/fetch-grphql";
import useJwt from "../../auth/jwt/useJwt";
import { toastification } from "../../@core/mixins/toastification";
import { isUserLoggedIn } from "../../auth/utils";
export default {
  name: "Header",
  data() {
    return {
      speciesList: [],
      speciesID: "",
      experimentId: "",
      experimentList: [],
      routerList: [
        "Home",
        "Login",
        "Register",
        "File Upload",
        "Species",
        "Experiments",
      ],
      isLoggedIn: "",
      isHomeRoute: false,
      userName: "",
      speciesTitle: "",
    };
  },
  created() {
    this.isLoggedIn = isUserLoggedIn();
    this.getUserName();
  },
  mixins: [toastification],
  beforeMount() {
    if (this.$route.path == "/") {
      this.getSpecies();
    }
    const index = this.routerList.indexOf(this.$route.name);
    if (index > -1) {
      this.isHomeRoute = true;
      this.routerList.splice(index, 1);
    }
    if (this.$route.path == "/fileupload") {
      this.routerList.splice(0, 3, "Home");
    }
    if (this.$route.path == "/species") {
      this.routerList.splice(0, 3, "Home");
    }
    if (this.$route.path == "/experiments") {
      this.routerList.splice(0, 3, "Home");
    }
    if (this.$route.path == "/" || this.$route.path == "/home") {
      this.routerList.splice(0, 3, "File Upload");
    }
    if (!this.isLoggedIn) {
      this.routerList.splice(0, 3, "Login", "Register");
    }
  },
  methods: {
    getUserName() {
      this.userName = localStorage.getItem(useJwt.jwtConfig.storageUserName);
    },
    getSpecies() {
      this.$apollo
        .query({
          query: GET_SPECIES,
        })
        .then((res) => {
          // console.log(res);
          this.speciesList =
            res.data.getSpecies.speciesList.length > 0
              ? res.data.getSpecies.speciesList
              : [];
          if (this.speciesList.length > 0) {
            // console.log("this.speciesList", this.speciesList);
            this.speciesID = res.data.getSpecies.speciesList[0].id;
            this.speciesTitle = this.speciesList.filter(
              (species) => this.speciesID === species.id
            )[0].name;
            this.getSpeciesName();
          }
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },
    getExperiments(speciesId) {
      this.$apollo
        .query({
          query: GET_EXPERIMENTS,
          variables: {
            species_id: speciesId,
          },
        })
        .then((res) => {
          this.experimentList = res.data.getExperiments.experimentList;
          if (this.experimentList.length) {
            this.experimentId = res.data.getExperiments.experimentList[0].id;
            let data = {
              experiment_id: res.data.getExperiments.experimentList[0].id,
            };
            //this.showLoading = true;
            this.$socket.emit("POST_CELL_EXP", data);
          }
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },
    onExperimentChange(data) {
      let expIndex = this.experimentList.findIndex(
        (element) => element.id === data
      );
      this.$emit("onExperimentChange", {
        experimentId: this.experimentId,
        expIndex,
      });
    },
    getSpeciesName() {
      this.$emit("getSpeciesTitle", this.speciesTitle);
    },
    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.clear();
      if (this.$route.path != "/") {
        this.$router.push("/");
      } else {
        this.$router.go();
      }
    },
  },
};
</script>
<style scoped>
.nav-link {
  padding: unset;
}
.navbar {
  padding: unset;
}
.navbar-horizontal {
  background-color: #ecf0f1;
}
.selectInput {
  width: 20rem;
}
.navbar-expand-lg .navbar-nav .nav-link {
  padding-left: 1.9rem;
}
</style>
